import React from 'react';
import { Box } from '@mui/material';

/**
 * Inline monospace `<code>` styling. MUI doesn't ship one, but we use
 * it on at least 4 pages (ApiKeys, Webhooks, PaymentsConfig, LowStock)
 * — so it lives here instead of being copy-pasted.
 *
 *   <Code>tpo_abc123_…</Code>
 *   <Code sx={{ display: 'block', p: '8px' }}>{longString}</Code>
 */
export default function Code({ children, sx }) {
  return (
    <Box
      component='code'
      sx={{
        fontFamily: 'monospace',
        fontSize: '0.85em',
        bgcolor: 'action.hover',
        px: '6px', py: '2px',
        borderRadius: '4px',
        wordBreak: 'break-all',
        ...sx,
      }}
    >
      {children}
    </Box>
  );
}
